import { StyleSheet } from '@react-pdf/renderer'

const CHART_WIDTH = 90

export const styles = StyleSheet.create({
  headerPerformance: {
    position: 'relative',
    width: CHART_WIDTH,
    height: CHART_WIDTH * 0.7,
  },
  performance: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 15,
  },
  performanceText: {
    fontSize: 12,
    fontWeight: 500,
    textAlign: 'center',
    position: 'absolute',
    bottom: CHART_WIDTH * 0.1 + 5,
    left: CHART_WIDTH * 0.5 - 10,
  },
  performanceItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
    marginBottom: 5,
  },
  performanceLabel: {
    fontSize: 5,
    fontWeight: 300,
    color: '#898C9A',
  },
  performanceValue: {
    fontSize: 5,
    paddingHorizontal: 4,
    paddingVertical: 2,
    borderRadius: 20,
    color: '#fff',
  },
  performanceValues: {
    flex: 1,
  },
  chartImage: {
    zIndex: -1,
    position: 'absolute',
    width: CHART_WIDTH,
  },
  section: {
    paddingHorizontal: 12,
    paddingVertical: 5,
    backgroundColor: '#fff',
    borderRadius: 5,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTopWidth: 0.5,
    borderTopColor: '#D8D9DD',
    paddingVertical: 7,
  },
  rowFirst: {
    borderTopWidth: 0,
  },
  rowLabel: {
    fontSize: 7,
    fontWeight: 500,
    marginBottom: 2,
  },
  rowStatusWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  rowDescription: {
    color: '#3B4056',
    fontSize: 5,
    maxWidth: 300,
    fontWeight: 300,
  },
  rowComment: {
    color: '#3B4056',
    fontSize: 5,
    width: 100,
    fontWeight: 300,
  },
  rowStatus: {
    fontSize: 5,
    paddingHorizontal: 4.5,
    paddingVertical: 2.5,
    borderRadius: 20,
    color: '#fff',
  },
})
